// 华龙酸菜旧版产品ID映射表
// 旧版URL格式: https://h5-hualong.vdvq.com/#/trace?product=35
// 新版URL格式: https://zsh5.tvtvc.com/#/trace?product_id=<uuid>

// 生产库 UUID（36位带连字符）
const PROD_UUID_MAP = {
  35: { name: '净酸菜（238g）',              uuid: '32951447-b991-4a49-be62-24675aeab77a' },
  36: { name: '酸菜脆笋（80g）',             uuid: 'f28ecbe6-01bf-49e2-8066-f760b1bc83b5' },
  37: { name: '酸菜香菇原味（80g）',         uuid: '22b0d765-3302-4076-94b2-a32f55c7768b' },
  38: { name: '酸菜牛肉酱香辣（80g）',       uuid: '35809ac6-afa8-46f0-a6b8-c62a4fc3f316' },
  39: { name: '酸菜牛肉酱原味（80g）',       uuid: '210a751f-ab97-45ac-ad19-7253af046a84' },
  40: { name: '酸菜香菇牛肉酱原味（80g/袋）', uuid: '66150aef-0b6c-4087-b179-7678303b6831' },
  41: { name: '酸菜牛肉酱香辣（230g/瓶）',   uuid: '0f2ba887-948c-4464-92f2-7689413f7f56' },
  42: { name: '酸菜牛肉酱原味（230g/瓶）',   uuid: '77456726-c5c0-4b3c-9802-0905cd615382' }
}

// 测试库 UUID（32位无连字符，测试环境 trace_product.id 格式不同）
const TEST_UUID_MAP = {
  35: { name: '净酸菜（238g）',              uuid: '32951447b99111efb01800163e0c6a17' },
  36: { name: '酸菜脆笋（80g）',             uuid: 'f28ecbe601bf11f0b01800163e0c6a17' },
  37: { name: '酸菜香菇原味（80g）',         uuid: '22b0d7653302110fb01800163e0c6a17' },
  38: { name: '酸菜牛肉酱香辣（80g）',       uuid: '35809ac6afa811efb01800163e0c6a17' },
  39: { name: '酸菜牛肉酱原味（80g）',       uuid: '210a751fab9711efb01800163e0c6a17' },
  40: { name: '酸菜香菇牛肉酱原味（80g/袋）', uuid: '66150aef0b6c11f0b01800163e0c6a17' },
  41: { name: '酸菜牛肉酱香辣（230g/瓶）',   uuid: '0f2ba887948c11efb01800163e0c6a17' },
  42: { name: '酸菜牛肉酱原味（230g/瓶）',   uuid: '77456726c5c011efb01800163e0c6a17' }
}

// 根据构建时注入的环境变量选择映射表
// .env.hualong_test  → VUE_APP_LEGACY_UUID_ENV=test
// .env.hualong_prod  → VUE_APP_LEGACY_UUID_ENV=prod（或未设置）
const LEGACY_PRODUCT_MAP =
  process.env.VUE_APP_LEGACY_UUID_ENV === 'test' ? TEST_UUID_MAP : PROD_UUID_MAP

/**
 * 判断是否是旧版整数产品ID
 */
export function isLegacyProductId(val) {
  const num = parseInt(val, 10)
  return !isNaN(num) && String(num) === String(val) && LEGACY_PRODUCT_MAP[num] !== undefined
}

/**
 * 获取旧版产品名称（用于日志）
 */
export function getLegacyProductName(val) {
  const num = parseInt(val, 10)
  return (LEGACY_PRODUCT_MAP[num] && LEGACY_PRODUCT_MAP[num].name) || '未知产品'
}

/**
 * 从URL参数中解析产品ID，返回 { paramName, paramValue } 或 null
 *
 * 支持:
 *   ?product_id=<uuid>  新版 → { paramName: 'product_id', paramValue: '<uuid>' }
 *   ?product=<integer>  旧版 → { paramName: 'product', paramValue: 35 }
 *
 * 后端接口同时支持两种参数:
 *   product_id -> UUID/hex 查询
 *   product    -> legacy_product_id 整数查询
 */
export function parseProductId() {
  // Hash 路由：参数在 hash 里（/#/trace?product=35），不在 search 里
  const hash = window.location.hash || ''
  const queryStr = hash.includes('?') ? hash.split('?')[1] : ''
  const urlParams = new URLSearchParams(queryStr)
  const productId = urlParams.get('product_id')
  const legacyProduct = urlParams.get('product')

  if (productId) {
    return { paramName: 'product_id', paramValue: productId }
  }

  if (legacyProduct) {
    const num = parseInt(legacyProduct, 10)
    if (!isNaN(num) && LEGACY_PRODUCT_MAP[num]) {
      // 华龙旧版整数 ID 直接映射为 UUID，后端统一用 product_id 查询，无需改后端
      return { paramName: 'product_id', paramValue: LEGACY_PRODUCT_MAP[num].uuid }
    }
    // 非华龙商户：?product=<ID> 兜底当作普通 product_id 使用（保持旧版行为）
    return { paramName: 'product_id', paramValue: legacyProduct }
  }

  return null
}
